const stagingStripeKey = 'pk_test_kdb9gWo6I9kxReT9AxhjoZmO00F3l7vcg7';
const prodStripeKey = 'pk_live_DeiSuIhNoWnaIQeHf9QfpTq700L3LodL6p';

module.exports = {
  stripeKey: stagingStripeKey
};
